import { Alert, Box, Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { assets } from "../assets";
import { appStates } from "../redux/features/appStateSlice";
import { setPlanSelected } from "../redux/features/planStateSlice";
import { updateUser } from "../redux/features/userStateSlice";
import { getMySubscriptionInfo } from "../utils";
import { LoaderComponent } from "./Loader";

export const PlanCheckoutSuccess = ({ subscriptionState }) => {
  const { planSelected } = useSelector((state) => state.planState);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAndUpdateSubscription = async () => {
      try {
        setIsLoading(true);
        const token = sessionStorage.getItem("token");

        await new Promise((resolve) => setTimeout(resolve, 1000));

        const freshData = await getMySubscriptionInfo(token);

        dispatch(
          updateUser({
            subscription: freshData?.subscription,
            benefits: freshData?.benefits || [],
          }),
        );

        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching subscription info:", err);
        setError(err?.message || "Error loading subscription details");
        setIsLoading(false);
      }
    };

    if (subscriptionState?.state === "success") {
      fetchAndUpdateSubscription();
    }
  }, [subscriptionState?.state, dispatch]);

  const handleGoHome = () => {
    dispatch(
      setPlanSelected({
        planSelected: undefined,
        ticket: undefined,
        upgradeFreeTrial: false,
        currState: appStates.PLANS,
        openPlanInfo: true,
      }),
    );

    navigate("/business/plan-center");
  };

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column" sx={{ minHeight: "400px" }}>
        <LoaderComponent />
      </Box>
    );
  }

  // Mostrar error si ocurre
  if (error) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column">
        <Typography variant="h5" color="error" sx={{ fontWeight: "bold", mb: 2 }}>
          Error Loading Subscription
        </Typography>
        <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
          {error}
        </Typography>
        <Button variant="contained" sx={{ backgroundColor: "#0068e6" }} onClick={handleGoHome}>
          Go Home Anyway
        </Button>
      </Box>
    );
  }

  const isPayAsYouGo = planSelected?.billingType === "PAY_AS_YOU_GO";
  const isFree = planSelected?.name === "Free";
  const scheduled = Boolean(subscriptionState?.data?.scheduled);

  const successTitle = scheduled
    ? "Plan updates at renewal"
    : isPayAsYouGo
      ? "Authorization Successful!"
      : isFree
        ? "Subscription Successful!"
        : "Payment successful!";

  const alertMessage = scheduled
    ? "Your card is saved. The charge happens automatically when your current plan expires."
    : isPayAsYouGo
      ? "Your payment method has been authorized for Pay-As-You-Go billing. Base plan and usage charges will be billed automatically on the 1st of each month."
      : isFree
        ? "Your plan details have been sent to your email."
        : "A receipt has been sent to your email.";

  return (
    <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column">
      <Typography variant="h4" color="initial" sx={{ fontWeight: "bold" }}>
        {successTitle}
      </Typography>
      <Box sx={{ width: "20%", height: "30%", mt: 2 }}>
        <img width="100%" height="100%" src={assets.images.sucessSubs} alt="Success" />
      </Box>

      <Alert severity="success" icon={false} sx={{ mt: 2, textAlign: "center" }}>
        <Typography variant="subtitle1" color="initial" sx={{ fontWeight: "bold" }}>
          {alertMessage}
        </Typography>
      </Alert>

      <Button variant="contained" sx={{ mt: 2, backgroundColor: "#0068e6" }} onClick={handleGoHome}>
        Go to Subscriptions
      </Button>
    </Box>
  );
};
